<script lang="ts">
    import s from './style.module.css';
    import {
        ADDED_TO_CART_LOCAL,
        IMAGE_COUNT_CLASS,
    } from 'desktop/templates/squareExitCartModal/constants';
    export const getCartItems = () => {
        const cart: {[s: string]: {img: string; name: string}} =
            JSON.parse(localStorage.getItem(ADDED_TO_CART_LOCAL)) || {};

        return Object.values(cart).slice(0, 3);
    };

    const cartItems = getCartItems();
</script>

<div class={s.images}>
    {#each cartItems as item}
        <img
            class="{s.image} {s[IMAGE_COUNT_CLASS[cartItems.length]] || ''}"
            src={item.img}
            alt={item.name}
        />
    {/each}
</div>
